import { FormattedMessage } from "react-intl";
import AppRowContainer from "@lib/components/AppComponents/AppRowContainer";
import { Col } from "antd";
import { useMemo } from "react";
import { ApiParams, CurrencyEnum } from "@lib/types";
import { useQuery } from "@tanstack/react-query";
import { DateRangeFilter } from "@lib/components/MiniComponents/Others";
import { apiGetAILogs } from "@lib/api/aiLog";
import {
  AICustomerDailyUsageChart,
  AIModelCustomerUsageChart,
} from "@lib/components/MiniComponents/Dashboard/AI";
import { AIWhiteLabelMiniCard } from "@app/admin/dashboards/components/MiniCards";
import MiniInfoCard from "@lib/components/MiniComponents/Dashboard/MiniInfoCard";
import { TbZoomMoney } from "react-icons/tb";
import { magenta } from "@ant-design/colors";
import { currencySymbol, formatCurrency } from "@lib/helpers/StringHelper";

type Props = {
  dateBetween: [string, string];
  setDateBetween: (date: [string, string]) => void;
};

const ManagementAIPayments: React.FC<Props> = ({ dateBetween }) => {
  const params = useMemo(() => {
    return {
      s: [
        {
          $and: [
            { createdAt: { $gte: dateBetween[0] } },
            { createdAt: { $lte: dateBetween[1] } },
          ],
        },
      ],
      join: ["customer"],
      sort: "createdAt,ASC",
    } as ApiParams;
  }, [dateBetween]);

  const query = useQuery({
    queryFn: () => apiGetAILogs(params),
    queryKey: ["ai-payments", JSON.stringify(params)],
    enabled: !!params,
  });
  const { data } = query;
  const apiData = data?.data?.data;

  const totalCost = useMemo(() => {
    return apiData?.reduce((acc, curr) => acc + Number(curr?.cost || 0), 0);
  }, [apiData]);

  // const totalActualCost = useMemo(() => {
  //   return apiData?.reduce(
  //     (acc, curr) => acc + Number(curr?.actualCost || 0),
  //     0,
  //   );
  // }, [apiData]);

  return (
    <AppRowContainer>
      <Col xs={24} md={24} lg={24} xl={24} style={{ marginBottom: 0 }}>
        <AppRowContainer>
          <Col xs={24} md={24} lg={12} xl={12}>
            <AIWhiteLabelMiniCard cardProps={{ borderFull: true }} />
          </Col>

          <Col xs={24} md={24} lg={12} xl={12}>
            <MiniInfoCard
              loading={query?.isLoading || query?.isFetching}
              data={{
                icon: <TbZoomMoney />,
                color: magenta[6],
                desc: (
                  <div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "flex-start",
                      }}
                    >
                      <FormattedMessage id="common.aiPayments" />
                      <DateRangeFilter
                        value={dateBetween}
                        onlyShowDate
                        showDateStyle={{ fontSize: 10 }}
                      />
                    </div>
                  </div>
                ),
                title: `${formatCurrency(totalCost)} ${currencySymbol(CurrencyEnum.USD)}`,
              }}
            />
          </Col>
        </AppRowContainer>
      </Col>

      <Col xs={24} md={24} lg={12} xl={12}>
        <AIModelCustomerUsageChart
          query={query}
          extra={<DateRangeFilter value={dateBetween} onlyShowDate />}
          refetch={() => query.refetch()}
        />
      </Col>

      <Col xs={24} md={24} lg={12} xl={12}>
        <AICustomerDailyUsageChart
          query={query}
          extra={<DateRangeFilter value={dateBetween} onlyShowDate />}
          refetch={() => query.refetch()}
        />
      </Col>
    </AppRowContainer>
  );
};

export default ManagementAIPayments;
